import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Template from 'components/cases/nri'

const Nri: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'UIUX モバイルアプリ システム化 DX推進 フロントエンド開発'}
        image={'https://www.i3design.jp/OGP_logo.png'}
        url={'https://www.i3design.jp/cases/nri'}
        title="東京スター銀行アプリ | 事例 | i3DESIGN アイスリーデザイン"
        description="銀行口座アプリのUIデザインを担当しました。デザイン思考のアプローチで元々あった機能一覧を再考し、モック制作、ユーザー調査からコンセプトを再設計して、UIデザインまで実施しました。"
      />
      <Template />
    </>
  )
}

export default Nri
